import React from "react";
import CloseIcon from "../../VerticalPlayer/Icons/Close";

interface SideFixedPanelProps {
  children: React.ReactNode;
  showOverlay: boolean;
  onOverlayClick?: () => void;
}

interface SideFixedPanelSectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  isOpen: boolean;
}

interface SideFixedPanelHeaderProps {
  title?: React.ReactNode;
  onClose: () => void;
}

const buildClassName = (...classNames: Array<string | false | null | undefined>) =>
  classNames.filter(Boolean).join(" ");

export const SideFixedPanelSection: React.FC<SideFixedPanelSectionProps> = ({
  children,
  className,
  id,
  isOpen,
}) => (
  <div
    id={id}
    className={buildClassName("side-fixed-panel-inner", className, isOpen && "open")}
  >
    {children}
  </div>
);

export const SideFixedPanelHeader: React.FC<SideFixedPanelHeaderProps> = ({
  title,
  onClose,
}) => (
  <header className="panel-header">
    <h4 className="panel-header-title">{title}</h4>
    <button type="button" className="popup-close" onClick={onClose}>
      <CloseIcon />
    </button>
  </header>
);

const SideFixedPanel: React.FC<SideFixedPanelProps> = ({
  children,
  onOverlayClick,
  showOverlay,
}) => (
  <div className="side-fixed-panel">
    {children}
    <div
      className={`overlay ${showOverlay ? "open" : ""}`}
      onClick={onOverlayClick}
    ></div>
  </div>
);

export default SideFixedPanel;
